import { render, staticRenderFns } from "./ui-edit-automodal.vue?vue&type=template&id=2375b5ec&"
import script from "./ui-edit-automodal.vue?vue&type=script&lang=js&"
export * from "./ui-edit-automodal.vue?vue&type=script&lang=js&"
import style0 from "./ui-edit-automodal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports